import MemoryPage from '../pages';
import DeckPage from '../pages/deck';
import DisciplineFlashcardsPage from '../pages/discipline-flashcards';
import ReviewFlashcard from '../pages/review-flashcard';

export const MemoryRoutes = [
  {
    path: '',
    element: <MemoryPage />,
  },
  {
    path: 'review-flashcards',
    element: <ReviewFlashcard />,
  },
  {
    path: 'deck/:deckUuid',
    element: <DeckPage />,
  },
  {
    path: 'flashcards/:disciplineUuid',
    element: <DisciplineFlashcardsPage />,
  },
];
